import { Colors } from '../constants';

const Theme = {
  dark: {
    name: 'dark',
    base: 'dark',
    bg: Colors.deepBlack,
    top: {
      title: Colors.white,
    },
    botBar: {
      icon: Colors.lightGray,
      active: Colors.white,
    },
    fav: {
      title: Colors.white,
      text: Colors.offWhite,
      stat: Colors.lightGray,
      rowBg: Colors.deepBlack,
      bg: Colors.darkBlueGray,
    },
  },
  dracula: {
    name: 'dracula',
    base: 'dark',
    bg: Colors.darkBlueGray,
    top: {
      title: Colors.white,
    },
    botBar: {
      icon: Colors.lightGray,
      active: Colors.white,
    },
    fav: {
      title: Colors.white,
      text: Colors.offWhite,
      stat: Colors.lightGray,
      rowBg: Colors.darkBlueGray,
      bg: Colors.midGray,
    },
  },
  light: {
    name: 'light',
    base: 'light',
    bg: Colors.lightBlueGray,
    top: {
      title: Colors.black,
    },
    botBar: {
      icon: Colors.lightGray,
      active: Colors.black,
    },
    fav: {
      title: Colors.black,
      text: Colors.darkSteel,
      stat: Colors.darkSteel,
      rowBg: Colors.lightBlueGray,
      bg: Colors.midLightBlueGray,
    },
  },
  bright: {
    name: 'bright',
    base: 'light',
    bg: Colors.white,
    top: {
      title: Colors.black,
    },
    botBar: {
      icon: Colors.lightGray,
      active: Colors.black,
    },
    fav: {
      title: Colors.black,
      text: Colors.darkSteel,
      stat: Colors.darkSteel,
      rowBg: Colors.white,
      bg: Colors.offWhite,
    },
  },
};

export default Theme;



// WEBPACK FOOTER //
// ./src/constants/Theme.js